module.exports = __webpack_public_path__ + "img/planBg.2535a546.png";